module.exports = Em.Handlebars.compile("{{view.day.label}}");